<nav class="breadcrumb" aria-label="Breadcrumb">
  <a
    class="breadcrumb-link"
    [routerLink]="tasksLink"
    [dataSelector]="'cxp-deliverable-detail-breadcrumb-tasks'"
    (click)="onTasksClicked()"
  >{{ breadcrumbRootLabel() }}</a>
  <span class="breadcrumb-sep" aria-hidden="true">/</span>
  <span class="breadcrumb-current" [dataSelector]="'cxp-deliverable-detail-breadcrumb-current'">{{ name() }}</span>
</nav>

<h1 class="deliverable-title" [dataSelector]="'cxp-deliverable-detail-title'">{{ displayedTitle() }}</h1>

<div class="deliverable-meta">
  @if (serviceLineName(); as line) {
    <pill size="small" color="gray" [value]="line" [dataSelector]="'cxp-deliverable-detail-service-line'"></pill>
  }
  @if (clientName(); as client) {
    <span class="deliverable-client" [dataSelector]="'cxp-deliverable-detail-client-name'">{{ client }}</span>
  }
</div>

@if (description()) {
  <p class="deliverable-description" [dataSelector]="'cxp-deliverable-detail-description'">
    <span>{{ displayedDescription() }}</span>
    @if (isTruncatable()) {
      <button
        type="button"
        class="deliverable-description-toggle"
        [dataSelector]="'cxp-deliverable-detail-description-toggle'"
        (click)="toggleExpanded()"
      >{{ toggleLabel() }}</button>
    }
  </p>
}
